import { render, staticRenderFns } from "./addItems.vue?vue&type=template&id=60db0dec&scoped=true&"
import script from "./addItems.vue?vue&type=script&lang=js&"
export * from "./addItems.vue?vue&type=script&lang=js&"
import style0 from "./addItems.vue?vue&type=style&index=0&id=60db0dec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60db0dec",
  null
  
)

export default component.exports